<template>
  <div id="app">
    <indexView />
  </div>
</template>

<script>
import indexView from './view/index.vue'
export default {
  name: 'App',
  components: {
    indexView
  }
}
</script>

<style>
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}
html,
body,
#app{
  width: 100%;
  height: 100%;
}
.box-card{
  min-height: 500px;
}
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.text {
  font-size: 14px;
}

.item {
  margin-bottom: 18px;
}

.box-card {
  width: 100%;
  height: 100%;
}
</style>
